import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { StorageService } from 'app/services/storage.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { EqualvalidatorDirective } from 'app/validators/equalvalidator.directive';
import { ToastrService } from 'ngx-toastr';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CountryISO, SearchCountryField, TooltipLabel } from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {
  form;
  params: any = {};
  isPhonePortrait = false;
  loginUser: any = { };
  systemCode: String = null;
  correspondencechoice: string=null;
  EmailAddress: string=null;
  MobileNumber: string=null;
  public isLoading = false;
  message = null;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;    
  defaultCountry:any = CountryISO.SouthAfrica;
  
  
  preferredCountries: CountryISO[] = [
    CountryISO.Angola,
     CountryISO.Botswana,
     CountryISO.Comoros,
     CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
     CountryISO.Lesotho,
     CountryISO.Madagascar,
     CountryISO.Malawi,
     CountryISO.Mauritius,
     CountryISO.Mozambique,
     CountryISO.Namibia,
     CountryISO.Seychelles,
     CountryISO.Swaziland,
     CountryISO.Zambia,
     CountryISO.Zimbabwe,
    ];
  
  constructor(public authWebService: AuthWebService,
    private router: Router,private toastService:ToastNotificationService,
    private route: ActivatedRoute,private responsive: BreakpointObserver,
     public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {
    this.responsive.observe([
			Breakpoints.HandsetLandscape,      
			Breakpoints.TabletLandscape,
			])
			.subscribe(result => {
	  
			 
				this.isPhonePortrait = false; 
	  
			  if (result.matches) {
				this.isPhonePortrait = true;
			  }
			});
    this.systemCode = environment.authWebApi.systemCode

    this.defaultCountry = this.defaultCountry;
    if(localStorage.getItem('isLogged') == 'true')
    {
      localStorage.clear();
      window.location.reload();
    }
    this.initForm();
  }
  initForm(){
    this.form = new FormGroup({
      EmailAddress: new FormControl("", Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      ,MobileNumber: new FormControl("")
    
  });
  
  }
  selectcorrespondenceType(typeVal){
    
    this.correspondencechoice=typeVal;
    
  }

  
  onSubmit(obj: any){

    if (this.correspondencechoice === null){
  
      return this.toastService.error('Please select how you want to receive the reset confirmation link!','Password Reset');
    
    }

    if (obj.EmailAddress === null)
    {
      return this.toastService.error('Enter Email address!','Password Reset');
    }
    obj.EmailAddress=obj.EmailAddress.toLowerCase();
    //send to authweb
    this.authWebService.passwordResetRequest(obj.EmailAddress, this.systemCode, this.correspondencechoice === "2" ? "SMS" : "EMAIL");
    
  }

  resetPassword(){
    if (this.loginUser.EmailAddress === null || this.loginUser.EmailAddress === undefined)
    {
      return this.toastService.error('Please enter your Email address!','Password Reset');
    }
    if (this.loginUser.MobileNumber === null || this.loginUser.MobileNumber === undefined){
      return this.toastService.error('Please enter your mobile number','Password Reset');
    }
    
    //send to authweb
    this.authWebService.passwordResetRequest(this.loginUser.EmailAddress, this.loginUser.MobileNumber.number, this.systemCode);
    
  }

  ChangeCountry(event){
    this.defaultCountry = event.iso2;
  }
 
}
